import React, { FunctionComponent } from 'react';
import { Link, Route, Switch, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { Color } from '../../config/Color';
import { DemoAppContainer } from '../styles/AppContainer';
import { Header } from '../styles/Header';
import { Heading } from '../styles/Typography';
import { DemoComponents } from './DemoComponents';
import { DemoElements } from './DemoElements';
import { DemoScreens } from './DemoScreens';
import { DemoTypography } from './DemoTypography';

export const Demo: FunctionComponent = () => {
  const { url } = useRouteMatch();

  const PAGES = [
    { name: 'Typography', Component: DemoTypography },
    { name: 'Components', Component: DemoComponents },
    { name: 'Elements', Component: DemoElements },
    { name: 'Screens', Component: DemoScreens },
  ];

  return (
    <>
      <SidebarLinks>
        <ul>
          {PAGES.map(({ name }) => (
            <li key={name}>
              <Link to={`${url}/${name.toLowerCase()}`}>{name}</Link>
            </li>
          ))}
        </ul>
      </SidebarLinks>
      <DemoAppContainer style={{ position: 'relative' }}>
        <Header />
        <Switch>
          {PAGES.map(({ name, Component }) => (
            <Route key={name} path={`${url}/${name.toLowerCase()}`}>
              <Component />
            </Route>
          ))}
        </Switch>
      </DemoAppContainer>
    </>
  );
};

const SidebarLinks = styled.div`
  position: fixed;
  left: 1em;
  top: 1em;
  border: 1px solid black;
  z-index: 9999;

  ul {
    padding: 1em;
    list-style-type: none;
    margin: 0;
  }
`;

export const DemoContainer = styled.div`
  margin: 0 auto;
  max-width: 375px;
  border: 1px dashed ${Color.decorative.onAccent};
`;

export const DemoHeader = styled(Heading)`
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  margin-left: -2em;
  margin-right: -2em;
  background: ${Color.surface.default};
`;

export const DemoComponent = styled.div`
  position: relative;
`;
